import { Action } from 'redux';

type ActionLog = {
  action: string;
  timestamp: string;
};

const actionLogReducer = (state = [] as ActionLog[], action: Action) =>
  state.concat({ action: action.type, timestamp: new Date().toISOString() });

export default actionLogReducer;
